<dhp-article-purchase-account-shell
  [eyebrowKey]="'pages.articlePurchase.accountVerify.eyebrow'"
  [titleKey]="titleKey()"
  [descriptionKey]="descriptionKey()"
>
  <p class="text-primary-text">
    {{ 'pages.articlePurchase.accountVerify.emailLabel' | translate }}
  </p>
</dhp-article-purchase-account-shell>
